<template>
  <div>
    <div
      v-if="isValidSubscription"
      id="select-payment-subscriber"
      class="py-2"
    >
      <div v-if="selectedSession.purchased">
        <div
          v-if="!banner"
          class="text-white"
        >
          This course is already in your account. Click
          <nuxt-link
            class="font-bold text-accent-light underline"
            to="/account/enrolled"
          >
            here
          </nuxt-link>
          to visit your account to access this course
        </div>
      </div>
      <div v-else>
        <div v-if="loading">
          <div class=" flex justify-center items-center">
            <div class="animate-spin rounded-full h-6 w-6 mr-4 border-b-2 border-white" />
            <h6 class="font-bold text-white text-sm">
              Processing...
            </h6>
          </div>
        </div>
        <div v-else-if="redirectLoading">
          <div class=" flex justify-center items-center">
            <div class="animate-spin rounded-full h-6 w-6 mr-4 border-b-2 border-white" />
            <h6 class="font-bold text-white text-sm">
              Redirecting to your account...
            </h6>
          </div>
        </div>
        <p
          v-else-if="isTwoHoursBeforeStartTime"
          class="font-bold"
        >
          This course starts soon or has already started. If you'd like to register, please call Summit Customer Service <br class="sm:hidden" />at (800) 433-9570 to register.
        </p>
        <div v-else-if="isIncludedInSubscription">
          <t-button
            v-if="selectedFormat === 'LIVE'"
            variant="ctaPrimary"
            :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 ||isTwoHoursBeforeStartTime }"
            @click="goToLive('SUBALLACCESS');"
          >
            Add to My Subscription
            <t-icon
              class="ml-2 mt-1"
              name="chevron-right"
            />
          </t-button>
          <t-button
            v-else
            variant="ctaPrimary"
            :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime }"
            @click="addToSubscription(selectedSession);"
          >
            Add to My Subscription
            <t-icon
              class="ml-2 mt-1"
              name="chevron-right"
            />
          </t-button>
        </div>
        <div v-else>
          <p
            v-if="!banner"
            class="py-2 text-white"
          >
            Your current subscription does not include this course. Please <nuxt-link
              to="/account/subscription"
              target="_blank"
              class="text-base"
            >
              upgrade here
            </nuxt-link> or contact customer service <a
              href="https://support.summit-education.com/hc/en-us/requests/new?_gl=1*1ny0yt*_gcl_au*OTkzNzYxMTE4LjE3MjY3NDg4MTk.*_ga*NDk2NjcwNDcyLjE3MjY3NDg4MTk.*_ga_QJDFPP6NQV*MTcyNzQ0MjI4My4xOC4xLjE3Mjc0NDIzMDIuNDEuMC4w"
              target="_blank"
            >here</a> to upgrade today.
          </p>
          <div v-if="$auth.loggedIn && $auth.user.freeTrialVoucherCount > 0 && selectedSession.freeTrial">
            <t-button
              v-if="btnState === 'addToCart'"
              id="cart-btn"
              class="text-sm"
              :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime || checkItemSelected }"
              variant="ctaPrimary"
              :loading="loadingItem"
              @click="addToSubscription(selectedSession);"
            >
              Register for Free!
            </t-button>
          </div>
          <div
            v-else
            class="md:flex-col md:justify-between md:items-center py-2 md:py-0"
          >
            <t-button
              v-if="btnState === 'addToCart'"
              id="cart-btn"
              class="text-sm mt-4 md:mt-0"
              variant="ctaPrimary"
              :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime || checkItemSelected }"
              :loading="loadingItem"
              @click="addItemToCart();"
            >
              Add to cart - ${{ selectedSession.price }} <t-icon
                name="chevron-right"
                class="ml-2 mt-1"
              />
            </t-button>
            <t-button
              v-else-if="btnState === 'checkout'"
              class="text-sm mt-4 md:mt-0"
              variant="ctaPrimary"
              :loading="loadingItem"
              @click="proceedToCheckout()"
            >
              Go to checkout
            </t-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriberPaymentBtn',
  props: {
    isValidSubscription: {
      type: Boolean,
      default: false,

    },
    selectedSession: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,

    },
    redirectLoading: {
      type: Boolean,
      default: false,

    },
    selectedFormat: {
      type: String,
      required: true,
    },
    loadingItem: {
      type: Boolean,
      default: false,

    },
    isBrochure: {
      type: Boolean,
      default: false,

    },
    btnState: {
      type: String,
      default: '',
    },
    isIncludedInSubscription: {
      type: Boolean,
      default: false,

    },
    isTwoHoursBeforeStartTime: {
      type: Boolean,
      default: false,

    },
    checkItemSelected: {
      type: Boolean,
      default: false,

    },
    banner: {
      type: Boolean,
      default: false,

    },

  },
  methods: {
    addToSubscription() {
      this.$emit('add-to-subscription');
    },
    proceedToCheckout() {
      this.$emit('proceed-to-checkout');
    },
    addItemToCart() {
      this.$emit('add-item-to-cart');
    },
    goToLive() {
      this.$emit('go-to-live');
    },
  },
};
</script>
